module.exports = __webpack_public_path__ + "img/alicja-limburska.584ef2ec.jpg";